<template>
    <div class="container">
        <PatientsListingFilters 
            :filters="params" 
            :sustain-unread-messages-count="sustainUnreadMessagesCount" 
            :order-options="orderOptions"
            @change="onFilters" 
        />
        
        <div class="matrix-panel">
            <div class="table-layout table-patient table-maintenance table-therapist">
                <TableHeader v-if="patients.length !== 0" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" :freemium="freemium" />

                <PatientsListingTableBody
                    ref="TableBody"
                    phase="sustain"
                    :freemium="freemium"
                    :params="params"
                    :freeze="freeze"
                    :deactivated="deactivated"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :class="{'patient-inactive': freeze || deactivated}" :patient="patient" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />
                </PatientsListingTableBody>
            </div>
        </div>
    </div>
</template>

<script>
import PatientRow from '@components/Coaches/PatientsMatrix/Sustain/PatientRow'
import TableHeader from '@components/Coaches/PatientsMatrix/Sustain/TableHeader'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader
    },
    extends: PatientsListing,
    props: {
        sustainUnreadMessagesCount: {
            type: Number,
            required: false
        },
        orderOptions: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
    },
    mounted() {
        $(function() {
            $('.item-maintenance').addClass('active')
        })
    }
}
</script>
